import { EmptyCartError } from '@wix/premium-cart-common';
import { CartApiClientUtils } from './cart-api-client.utils';
export const upsertLineItems = async (httpClient, lineItems) => {
  const getExisitingLineItemInCart = (cart, lineItemToUpsert) => {
    var _cart$lineItems;
    return cart == null || (_cart$lineItems = cart.lineItems) == null ? void 0 : _cart$lineItems.find(cartLineItem => {
      var _lineItemToUpsert$pro, _lineItemToUpsert$pro2, _cartLineItem$product;
      return Boolean((_lineItemToUpsert$pro = lineItemToUpsert.productInfo) == null ? void 0 : _lineItemToUpsert$pro.productTypeId) && ((_lineItemToUpsert$pro2 = lineItemToUpsert.productInfo) == null ? void 0 : _lineItemToUpsert$pro2.productTypeId) === ((_cartLineItem$product = cartLineItem.productInfo) == null ? void 0 : _cartLineItem$product.productTypeId);
    });
  };
  const {
    getActiveCart,
    ambassadorUpdateLineItems,
    ambassadorAddLineItemsToActiveCart
  } = await CartApiClientUtils.dynamicLoadCartQueries(httpClient);
  if (!lineItems.length) {
    throw new Error('upsertLineItems request params error');
  }
  const {
    cart
  } = await getActiveCart({});
  const lineItemsToUpsert = lineItems;
  const existingLineItems = [];
  const newLineItems = [];
  lineItemsToUpsert.forEach(lineItemToUpsert => {
    const existingLineItem = cart ? getExisitingLineItemInCart(cart, lineItemToUpsert) : null;
    if (existingLineItem) {
      var _lineItemToUpsert$pro3;
      existingLineItems.push({
        cycle: lineItemToUpsert == null ? void 0 : lineItemToUpsert.cycle,
        lineItemId: (lineItemToUpsert == null ? void 0 : lineItemToUpsert.id) ?? (existingLineItem == null ? void 0 : existingLineItem.id),
        metadata: lineItemToUpsert == null ? void 0 : lineItemToUpsert.metadata,
        productId: lineItemToUpsert == null || (_lineItemToUpsert$pro3 = lineItemToUpsert.productInfo) == null ? void 0 : _lineItemToUpsert$pro3.productId,
        seats: lineItemToUpsert == null ? void 0 : lineItemToUpsert.seats
      });
    } else {
      newLineItems.push(lineItemToUpsert);
    }
  });
  let updatedCartResponse = null;
  if (existingLineItems.length) {
    if (!(cart != null && cart.id)) {
      throw new Error('upsertLineItems id not found in cart');
    }
    if (!cart.revision) {
      throw new Error('upsertLineItems revision not found in cart');
    }
    updatedCartResponse = await ambassadorUpdateLineItems({
      cartId: cart.id,
      revision: cart.revision,
      lineItems: existingLineItems
    });
  }
  if (newLineItems.length) {
    updatedCartResponse = await ambassadorAddLineItemsToActiveCart({
      lineItems: newLineItems
    });
  }
  const {
    cart: updatedCart
  } = updatedCartResponse ?? {};
  if (!updatedCart) {
    throw new EmptyCartError({});
  }
  return {
    cart: updatedCart
  };
};
//# sourceMappingURL=upsertLineItems.utils.js.map